import { useEffect, useState } from 'react';
import { useTeacherRetentionHistoryGet } from 'actions/teacher-performance';
import { useParams } from 'react-router-dom';
import { retentionHistoryImportMapper } from './helper';

const useLogic = () => {
  const { teacherId } = useParams();
  const [tableFilter, setTableFilter] = useState({
    status: [],
  });

  const {
    get: getRetentionHistory,
    data,
    isProcessing: isLoading,
  } = useTeacherRetentionHistoryGet(teacherId);

  const retentionHistory = retentionHistoryImportMapper(data ?? {});

  useEffect(() => {
    getRetentionHistory(teacherId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teacherId]);

  const handleFilterChange = (key, value) => {
    setTableFilter({
      ...tableFilter,
      [key]: value,
    });
  };
  const filteredStudents =
    retentionHistory?.students?.filter(({ status }) => {
      if (tableFilter?.status?.length) {
        return tableFilter?.status?.includes(status);
      }
      return true;
    }) ?? [];

  return {
    tableFilter,
    isLoading,
    retentionHistory,
    filteredStudents,
    handleFilterChange,
  };
};

export default useLogic;
